import React, { useEffect, useImperativeHandle, forwardRef } from "react";
import { useFormik, Form, FormikProvider, useField, useFormikContext, ErrorMessage, Field, getIn } from "formik";
import Input from "../Input";
import { Select, Option } from "../select";
import TextArea from "../textarea";
import Radio from "../radio/Radio";
import DatePicker from "../DatePicker";
import Switch from "../Switch";

const isRequiredField = ({ validationSchema }, name) => {
  try {
    return validationSchema.describe().fields[name].tests[0].name === "required"
  }catch {
    return false
  }
  
  // return !!getIn(validationSchema.describe().fields, name).tests.find( testName => testName === 'required' )
}
  

const QgForm = ({ children, ...props }, ref) => {
  const formik = useFormik(props);

  // 回车触发submit
  const onKeydownCode = (e) => {
    // if (e.key === 'Enter') {
    //   formik.handleSubmit()
    // }
  };

  useImperativeHandle(ref, () => {
    return {
      formik
    }
  }, []);

  return (
    <FormikProvider value={{...formik, ...props}}>
      <Form onKeyDown={onKeydownCode}>
        {children}
      </Form>
    </FormikProvider>
  )
};

export default forwardRef(QgForm);



export const FormItem = (props) => {
  const { setFieldValue, validationSchema } = useFormikContext();
  const [field, meta, helpers] = useField(props);

  let isRequired = validationSchema? isRequiredField({ validationSchema }, field.name): false;

  const [didFocus, setDidFocus] = React.useState(false);
  const handleFocus = () => setDidFocus(true);
  const showFeedback = (!!didFocus && field.value.trim().length > 2) || meta.touched;

  const { labelname, labelclass, id, labelPostion = "top", name } = props;
  const { type = "text", error, helperText = "" } = props;

  const boxClass = labelPostion === "left" ? 'flex items-center relative' : 'block';

  return (
    <div id={id} className={`${boxClass} ${labelclass}`}>

      {/* 标题 */}
      <label className={`${labelPostion === "left" ? 'inline' : 'block'} font-bold mr-2 flex item-center`}>
        <span className="text-red-500 mr-2">{isRequired ? '*': ''}</span>
        {labelname}
      </label>

      {/* 输入框 #11a1c8*/}
      {type === "text" || type === "color" ? <Input
        {...props}
        {...field}
        aria-describedby={`${id}-feedback ${id}-help`}
        handleFocus={handleFocus}
        borderColor={meta.error && showFeedback ? "red" : "gray"}
        focusWithinColor={meta.error && showFeedback ? "red" : "sprimary"}
      /> : null}

      {/* 下拉框 */}
      {type === "select" ? <Select
        handleSelectChange={(value) => { setFieldValue(field.name, value); props.onChange && props.onChange(value); }}
        {...field}
        {...props}
      /> : null}

      {/* 多行文本 */}
      {type === "textArea" ? <TextArea {...field} {...props} className={props.textarreaclass}/> : null}

      {/* 单选按钮 */}
      {type === "radio" ? <Radio {...field} {...props}/> : null}

      {/* switch */}
      {type === "switch" ? <Switch {...field} {...props} checked={field.value} onChange={(value) => {setFieldValue(field.name, value)}} /> : null}

      {/* 日历 */}
      {type === "date" ? <DatePicker {...field} {...props} handleDateChange={(value) => setFieldValue(field.name, value)}/> : null}

      {showFeedback ? (
        <div
          id={`${id}-feedback`}
          aria-live="polite"
          className="feedback text-sm text-red-500 ml-2 h-4"
        >
          {meta.error ? meta.error : null}
        </div>
      ) : <div className="w-3 h-4"></div>}
    </div>
  );
};
